import React, { useState, useEffect } from 'react';

// O que o cliente vê. Mostra o que já temos registado para aquele projeto e
// pede confirmação — só pede para escrever quando alguma coisa muda.
// Sem login: chega-se por link com código.
const FN = 'https://btdlohjmjogzkefjmvpn.supabase.co/functions/v1/formulario-cliente';
const ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ0ZGxvaGptam9nemtlZmptdnBuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg2NjY1NDQsImV4cCI6MjA5NDI0MjU0NH0.arGuxfOHhMVC-mH_qe7fjP_fsj__l9NI4xr_jyWZwSo';

const C = {
  roxo:'#691FB1', roxoClaro:'#EDE7F6', rosa:'#FF357B',
  txt:'#1A1A2E', txtMed:'#4A4A6A', txtClaro:'#8888AA',
  borda:'#E4DEFA', fundo:'#F7F5FC', branco:'#fff',
  verde:'#1E8449', verdeClaro:'#EAFAF1',
  ambar:'#B9770E', ambarClaro:'#FDF8E7',
  vermelho:'#C0392B', vermelhoClaro:'#FDECEA',
};
const F = "'DM Sans',sans-serif";

const inp = {
  width:'100%', padding:'10px 12px', borderRadius:8, border:`1px solid ${C.borda}`,
  fontSize:14, fontFamily:F, color:C.txt, boxSizing:'border-box', outline:'none', background:C.branco,
};
const lbl = { fontSize:11.5, fontWeight:700, color:C.txtMed, marginBottom:5, display:'block' };

// Fora do componente: se estivesse dentro, era recriado a cada tecla e os
// campos perdiam o foco ao escrever.
function Campo({ label, valor, onChange, placeholder, tipo='text', obrigatorio, largura }) {
  return (
    <div style={{ flex: largura || 1, minWidth:170 }}>
      <label style={lbl}>{label}{obrigatorio && <span style={{ color:C.rosa }}> *</span>}</label>
      <input type={tipo} value={valor||''} onChange={e=>onChange(e.target.value)}
        placeholder={placeholder} style={inp}/>
    </div>
  );
}

function Caixa({ children, style }) {
  return (
    <div style={{ background:C.branco, border:`1px solid ${C.borda}`, borderRadius:12,
      padding:'18px 20px', marginBottom:16, ...style }}>{children}</div>
  );
}

function Linha({ etiqueta, valor }) {
  if (!valor) return null;
  return (
    <div style={{ display:'flex', gap:10, padding:'4px 0', fontSize:13.5, lineHeight:1.5 }}>
      <span style={{ color:C.txtClaro, minWidth:112, flexShrink:0 }}>{etiqueta}</span>
      <span style={{ color:C.txt }}>{valor}</span>
    </div>
  );
}

export default function FormularioCliente() {
  const codigo = new URLSearchParams(window.location.search).get('c') || '';
  const [estado, setEstado] = useState('carregar');   // carregar | erro | form | feito | jaFeito
  const [erro, setErro] = useState('');
  const [dados, setDados] = useState(null);           // o que já temos registado

  const [decisao, setDecisao] = useState('');         // manter | po | contacto | entidade
  const [poNumero, setPoNumero] = useState('');
  const [poValidade, setPoValidade] = useState('');
  const [contactoNome, setContactoNome] = useState('');
  const [contactoEmail, setContactoEmail] = useState('');
  const [entidadeNova, setEntidadeNova] = useState({
    designacao_fiscal:'', nif:'', morada:'', codigo_postal:'',
    email_faturacao:'', prazo_pagamento_dias:'', contacto_fin_nome:'', contacto_fin_email:'',
  });
  const [contactos, setContactos] = useState([]);
  const [quem, setQuem] = useState({ nome:'', email:'' });
  const [aGravar, setAGravar] = useState(false);

  const chamar = async (body) => {
    const r = await fetch(FN, {
      method:'POST',
      headers:{ 'Content-Type':'application/json', Authorization:`Bearer ${ANON}` },
      body: JSON.stringify({ codigo, ...body }),
    });
    return r.json();
  };

  useEffect(() => {
    if (!codigo) { setErro('Falta o código no link.'); setEstado('erro'); return; }
    (async () => {
      const j = await chamar({ acao:'abrir' });
      if (j.error) { setErro(j.error); setEstado('erro'); return; }
      if (j.jaPreenchido) { setDados(j); setEstado('jaFeito'); return; }
      setDados(j);
      setContactos((j.contactos||[]).map(c => ({
        nome:c.nome||'', email:c.email||'', telefone:c.telefone||'',
        funcao:c.funcao||'', principal:!!c.principal,
      })));
      setContactoNome(j.contactoFatura?.nome || '');
      setContactoEmail(j.contactoFatura?.email || '');
      setEstado('form');
    })();
  }, []); // eslint-disable-line

  const setCon = (i,k,v) => setContactos(cs => cs.map((c,j)=> j===i ? {...c,[k]:v} : c));
  const setEnt = (k,v) => setEntidadeNova(e => ({...e,[k]:v}));

  const submeter = async () => {
    if (!quem.nome.trim() || !quem.email.trim()) { alert('Diga-nos o seu nome e email.'); return; }
    if (!decisao) { alert('Indique se os dados estão corretos ou o que precisa de mudar.'); return; }
    if (decisao === 'entidade' && (!entidadeNova.nif.trim() || !entidadeNova.designacao_fiscal.trim())) {
      alert('Para faturar a outra empresa, indique a designação fiscal e o NIF.'); return;
    }
    if (decisao === 'po' && !poNumero.trim()) { alert('Indique o número da nota de encomenda.'); return; }

    setAGravar(true);
    const j = await chamar({
      acao:'submeter',
      decisao,
      quemNome: quem.nome.trim(), quemEmail: quem.email.trim(),
      poNumero: (decisao==='po' || decisao==='entidade') ? poNumero.trim() : '',
      poValidade: poValidade || null,
      contactoNome: decisao==='contacto' ? contactoNome.trim() : '',
      contactoEmail: decisao==='contacto' ? contactoEmail.trim() : '',
      entidadeNova: decisao==='entidade' ? entidadeNova : null,
      contactos: contactos.filter(c => c.nome?.trim()),
    });
    setAGravar(false);
    if (j.error) { alert(j.error); return; }
    setEstado('feito');
  };

  /* ── estados simples ── */
  if (estado === 'carregar') return (
    <div style={{ fontFamily:F, padding:60, textAlign:'center', color:C.txtClaro }}>A carregar…</div>
  );

  if (estado === 'erro') return (
    <div style={{ fontFamily:F, background:C.fundo, minHeight:'100vh', padding:'60px 20px' }}>
      <div style={{ maxWidth:520, margin:'0 auto', background:C.branco, borderRadius:14, padding:32,
        textAlign:'center', border:`1px solid ${C.borda}` }}>
        <div style={{ fontSize:32, marginBottom:12 }}>🔒</div>
        <h1 style={{ fontSize:19, color:C.txt, margin:'0 0 10px' }}>Não foi possível abrir</h1>
        <p style={{ fontSize:14, color:C.txtMed, lineHeight:1.6, margin:0 }}>{erro}</p>
        <p style={{ fontSize:13, color:C.txtClaro, marginTop:18 }}>Precisa de ajuda? <strong>geral@workwell.pt</strong></p>
      </div>
    </div>
  );

  if (estado === 'jaFeito' || estado === 'feito') return (
    <div style={{ fontFamily:F, background:C.fundo, minHeight:'100vh', padding:'60px 20px' }}>
      <div style={{ maxWidth:520, margin:'0 auto', background:C.branco, borderRadius:14, padding:32,
        textAlign:'center', border:`1px solid ${C.borda}` }}>
        <div style={{ fontSize:34, marginBottom:12 }}>✓</div>
        <h1 style={{ fontSize:20, color:C.verde, margin:'0 0 10px' }}>
          {estado === 'feito' ? 'Obrigado!' : 'Já recebemos a sua confirmação'}
        </h1>
        <p style={{ fontSize:14.5, color:C.txtMed, lineHeight:1.65, margin:0 }}>
          {estado === 'feito'
            ? 'Ficou registado. A faturação deste projeto segue estas indicações.'
            : 'Este pedido já foi respondido. Se precisar de alterar alguma coisa, fale connosco.'}
        </p>
        <p style={{ fontSize:13, color:C.txtClaro, marginTop:20 }}>
          Qualquer questão: <strong>financeiro@workwell.pt</strong>
        </p>
      </div>
    </div>
  );

  /* ── formulário ── */
  const e = dados.entidade;
  const opcao = (valor, titulo, descricao) => (
    <label key={valor} style={{ display:'flex', alignItems:'flex-start', gap:10, padding:'11px 13px',
      border:`1.5px solid ${decisao===valor ? C.roxo : C.borda}`, borderRadius:9, marginBottom:8,
      background: decisao===valor ? C.roxoClaro : C.branco, cursor:'pointer' }}>
      <input type="radio" name="decisao" checked={decisao===valor} onChange={()=>setDecisao(valor)}
        style={{ accentColor:C.roxo, marginTop:3, cursor:'pointer' }}/>
      <span>
        <span style={{ fontSize:14, fontWeight:700, color: decisao===valor ? C.roxo : C.txt }}>{titulo}</span>
        <span style={{ display:'block', fontSize:12.5, color:C.txtClaro, marginTop:2, lineHeight:1.5 }}>{descricao}</span>
      </span>
    </label>
  );

  return (
    <div style={{ fontFamily:F, background:C.fundo, minHeight:'100vh', padding:'32px 20px 60px' }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Fraunces:wght@700&display=swap" rel="stylesheet"/>
      <div style={{ maxWidth:720, margin:'0 auto' }}>

        <div style={{ background:C.roxo, borderRadius:'14px 14px 0 0', padding:'22px 26px' }}>
          <div style={{ color:'rgba(255,255,255,.75)', fontSize:12.5, marginBottom:4 }}>Workwell · dados para faturação</div>
          <h1 style={{ color:'#fff', fontSize:22, margin:0, fontFamily:"'Fraunces',serif" }}>{dados.cliente}</h1>
          {dados.projeto && (
            <div style={{ color:'rgba(255,255,255,.9)', fontSize:14, marginTop:5 }}>{dados.projeto}</div>
          )}
        </div>
        <div style={{ background:C.branco, border:`1px solid ${C.borda}`, borderTop:'none',
          borderRadius:'0 0 14px 14px', padding:'18px 26px', marginBottom:20 }}>
          <p style={{ fontSize:14, color:C.txtMed, lineHeight:1.65, margin:0 }}>
            Antes de emitirmos a primeira fatura deste programa, queremos confirmar consigo
            os dados que temos registados. Demora um minuto.
          </p>
        </div>

        {/* O QUE TEMOS */}
        <Caixa>
          <h2 style={{ fontSize:15.5, color:C.roxo, margin:'0 0 12px' }}>O que temos registado</h2>
          {e ? (
            <div style={{ background:C.fundo, borderRadius:9, padding:'13px 16px' }}>
              <Linha etiqueta="Empresa" valor={e.designacao_fiscal}/>
              <Linha etiqueta="NIF" valor={e.nif}/>
              <Linha etiqueta="Morada" valor={[e.morada, e.codigo_postal].filter(Boolean).join(', ')}/>
              <Linha etiqueta="Faturas para" valor={dados.contactoFatura?.email}/>
              <Linha etiqueta="Prazo" valor={e.prazo_pagamento_dias ? `${e.prazo_pagamento_dias} dias` : null}/>
              <Linha etiqueta="Nota de encomenda" valor={dados.po ? `${dados.po.numero}${dados.po.validade ? ` (até ${dados.po.validade})` : ''}` : null}/>
            </div>
          ) : (
            <div style={{ fontSize:13.5, color:C.ambar, background:C.ambarClaro, borderRadius:9,
              padding:'12px 15px', lineHeight:1.6 }}>
              Ainda não temos dados de faturação registados. Escolha abaixo a última opção para nos indicar.
            </div>
          )}
        </Caixa>

        {/* DECISÃO */}
        <Caixa>
          <h2 style={{ fontSize:15.5, color:C.roxo, margin:'0 0 4px' }}>Está tudo correto para este programa?</h2>
          <p style={{ fontSize:12.5, color:C.txtClaro, margin:'0 0 13px' }}>Escolha uma opção.</p>

          {e && opcao('manter', 'Sim, está tudo correto', 'Mantemos os dados acima para a faturação deste programa.')}
          {e && opcao('po', 'Há uma nota de encomenda a indicar', 'O resto mantém-se — muda apenas o número de PO.')}
          {e && opcao('contacto', 'A fatura deve ir para outra pessoa', 'A empresa e os dados fiscais mantêm-se.')}
          {opcao('entidade', e ? 'Este programa é faturado a outra empresa' : 'Indicar os dados de faturação',
            e ? 'Empresa diferente da que está acima — com NIF próprio.' : 'Designação fiscal, NIF, morada e contacto.')}

          {decisao === 'po' && (
            <div style={{ display:'flex', gap:12, flexWrap:'wrap', marginTop:12, paddingTop:13, borderTop:`1px solid ${C.borda}` }}>
              <Campo label="Número da nota de encomenda" valor={poNumero} onChange={setPoNumero} obrigatorio largura={2}/>
              <Campo label="Válida até" valor={poValidade} onChange={setPoValidade} tipo="date"/>
            </div>
          )}

          {decisao === 'contacto' && (
            <div style={{ display:'flex', gap:12, flexWrap:'wrap', marginTop:12, paddingTop:13, borderTop:`1px solid ${C.borda}` }}>
              <Campo label="Nome" valor={contactoNome} onChange={setContactoNome}/>
              <Campo label="Email para onde enviamos as faturas" valor={contactoEmail} onChange={setContactoEmail} tipo="email" obrigatorio largura={2}/>
            </div>
          )}

          {decisao === 'entidade' && (
            <div style={{ marginTop:12, paddingTop:13, borderTop:`1px solid ${C.borda}` }}>
              <div style={{ display:'flex', gap:12, flexWrap:'wrap', marginBottom:11 }}>
                <Campo label="Designação fiscal" valor={entidadeNova.designacao_fiscal}
                  onChange={v=>setEnt('designacao_fiscal',v)} placeholder="nome completo da empresa" obrigatorio largura={2}/>
                <Campo label="NIF" valor={entidadeNova.nif} onChange={v=>setEnt('nif',v)} obrigatorio/>
              </div>
              <div style={{ display:'flex', gap:12, flexWrap:'wrap', marginBottom:11 }}>
                <Campo label="Morada" valor={entidadeNova.morada} onChange={v=>setEnt('morada',v)} largura={3}/>
                <Campo label="Código postal" valor={entidadeNova.codigo_postal} onChange={v=>setEnt('codigo_postal',v)} placeholder="0000-000"/>
              </div>
              <div style={{ display:'flex', gap:12, flexWrap:'wrap', marginBottom:11 }}>
                <Campo label="Email para onde enviamos as faturas" valor={entidadeNova.email_faturacao}
                  onChange={v=>setEnt('email_faturacao',v)} tipo="email" largura={2}/>
                <Campo label="Prazo de pagamento (dias)" valor={entidadeNova.prazo_pagamento_dias}
                  onChange={v=>setEnt('prazo_pagamento_dias',v)} tipo="number" placeholder="30"/>
              </div>
              <div style={{ display:'flex', gap:12, flexWrap:'wrap', marginBottom:11 }}>
                <Campo label="Contacto financeiro" valor={entidadeNova.contacto_fin_nome} onChange={v=>setEnt('contacto_fin_nome',v)}/>
                <Campo label="Email do contacto financeiro" valor={entidadeNova.contacto_fin_email}
                  onChange={v=>setEnt('contacto_fin_email',v)} tipo="email" largura={2}/>
              </div>
              <div style={{ display:'flex', gap:12, flexWrap:'wrap' }}>
                <Campo label="Nota de encomenda (se aplicável)" valor={poNumero} onChange={setPoNumero}/>
                <Campo label="Válida até" valor={poValidade} onChange={setPoValidade} tipo="date"/>
              </div>
              <div style={{ fontSize:11.5, color:C.txtClaro, marginTop:9, lineHeight:1.6 }}>
                Estes dados aplicam-se a este programa. Os restantes continuam a ser faturados como até aqui.
              </div>
            </div>
          )}
        </Caixa>

        {/* CONTACTOS */}
        <Caixa>
          <div style={{ display:'flex', alignItems:'baseline', gap:10, marginBottom:4 }}>
            <h2 style={{ fontSize:15.5, color:C.roxo, margin:0 }}>Quem acompanha o programa</h2>
            <span style={{ fontSize:12, color:C.txtClaro }}>do vosso lado</span>
          </div>
          {contactos.length === 0 && (
            <p style={{ fontSize:12.5, color:C.txtClaro, margin:'6px 0 10px' }}>
              Ainda não temos ninguém indicado. Acrescente quem devemos contactar.
            </p>
          )}
          {contactos.map((c,i)=>(
            <div key={i} style={{ borderTop: i>0?`1px solid ${C.borda}`:'none', paddingTop: i>0?14:10, marginTop: i>0?14:0 }}>
              <div style={{ display:'flex', gap:12, flexWrap:'wrap', marginBottom:10 }}>
                <Campo label="Nome" valor={c.nome} onChange={v=>setCon(i,'nome',v)} largura={2}/>
                <Campo label="Função" valor={c.funcao} onChange={v=>setCon(i,'funcao',v)} placeholder="ex.: Diretora de RH"/>
              </div>
              <div style={{ display:'flex', gap:12, flexWrap:'wrap', alignItems:'flex-end' }}>
                <Campo label="Email" valor={c.email} onChange={v=>setCon(i,'email',v)} tipo="email" largura={2}/>
                <Campo label="Telefone" valor={c.telefone} onChange={v=>setCon(i,'telefone',v)}/>
                {contactos.length>1 && (
                  <button onClick={()=>setContactos(cs=>cs.filter((_,j)=>j!==i))}
                    style={{ background:C.vermelhoClaro, border:`1px solid ${C.vermelho}33`, color:C.vermelho,
                      borderRadius:8, padding:'9px 13px', fontSize:12.5, cursor:'pointer', fontFamily:F }}>Remover</button>
                )}
              </div>
            </div>
          ))}
          <button onClick={()=>setContactos(cs=>[...cs,{ nome:'',email:'',telefone:'',funcao:'',principal:cs.length===0 }])}
            style={{ background:C.roxoClaro, border:'none', color:C.roxo, borderRadius:8, padding:'8px 14px',
              fontSize:12.5, fontWeight:700, cursor:'pointer', marginTop:14, fontFamily:F }}>
            + Acrescentar contacto
          </button>
        </Caixa>

        {/* QUEM CONFIRMA */}
        <Caixa style={{ background:'#FAF8FF' }}>
          <h2 style={{ fontSize:15, color:C.roxo, margin:'0 0 4px' }}>Quem confirma</h2>
          <p style={{ fontSize:12.5, color:C.txtClaro, margin:'0 0 12px' }}>
            Para sabermos com quem falar se houver alguma dúvida.
          </p>
          <div style={{ display:'flex', gap:12, flexWrap:'wrap' }}>
            <Campo label="O seu nome" valor={quem.nome} onChange={v=>setQuem(q=>({...q,nome:v}))} obrigatorio/>
            <Campo label="O seu email" valor={quem.email} onChange={v=>setQuem(q=>({...q,email:v}))} tipo="email" obrigatorio/>
          </div>
        </Caixa>

        <button onClick={submeter} disabled={aGravar}
          style={{ width:'100%', background:aGravar?C.txtClaro:C.roxo, border:'none', color:'#fff',
            borderRadius:10, padding:'15px', fontSize:15, fontWeight:700,
            cursor:aGravar?'default':'pointer', fontFamily:F }}>
          {aGravar ? 'A enviar…' : decisao === 'manter' ? 'Confirmar' : 'Confirmar e enviar'}
        </button>
        <p style={{ fontSize:11.5, color:C.txtClaro, textAlign:'center', marginTop:14, lineHeight:1.6 }}>
          Os dados são usados apenas para a faturação e gestão do vosso programa.
        </p>
      </div>
    </div>
  );
}
